import { http } from './client';

/**
 * Conditional GET for polled views (the live map): sends the ETag we hold and
 * keeps the previous data on 304, so an unchanged resource costs the server a
 * single small query and the browser no re-render. 401s still refresh and retry
 * through the shared interceptor, because 401 stays outside validateStatus.
 */
export function createConditionalGetter<T>(path: string): (signal?: AbortSignal) => Promise<T> {
  let etag: string | null = null;
  let last: T | undefined;
  return async (signal?: AbortSignal): Promise<T> => {
    const response = await http.get<T>(path, {
      signal,
      headers: etag && last !== undefined ? { 'If-None-Match': etag } : {},
      validateStatus: (status) => (status >= 200 && status < 300) || status === 304,
    });
    if (response.status === 304 && last !== undefined) return last;
    etag = (response.headers['etag'] as string | undefined) ?? null;
    last = response.data;
    return last;
  };
}
